export default "__VITE_ASSET__mdEBNnts__"